import React from 'react';
import { DmBreadcrumb } from "dm-react-ui";

function DmBreadcrumbCustom({routes, onTranslateCallback}) {
    const itemRenderBreadcrumb = (route, params, routes, paths) => {
        const last = routes.indexOf(route) === routes.length - 1;
        return last ? (
          <span>{route.i18n ? onTranslateCallback(route.breadcrumbName):route.breadcrumbName}</span>
        ) : (
          <a onClick={() => singleSpaNavigate(route.path)} style={{textTransform: 'capitalize'}}>{route.i18n ? onTranslateCallback(route.breadcrumbName):route.breadcrumbName}</a>
        );
      };

    return (<DmBreadcrumb itemRender={itemRenderBreadcrumb} routes={routes} separator=">" />)
}

export default DmBreadcrumbCustom;
